const Code = (props: any) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: `<div className="cm-code">${props?.value}</div>` }} />
    )
}

export { Code }